export const dbnCloudMenus = () => ({

    
  id: `main-menu-2-all`,
  path: '/management/dbn-cloud/dbn-cockpit',
  label: 'DBN Cloud',
  Description: 'E-Apps can also track and observe Employee, Finance etc and use it to offer custom recommendations and updates to the users. Furthermore.',
  isEnabled: true,
  svg: (
    <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M20 3h-3V2H7v1H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V7h16v14zm-6-9h-4v-1h4v1zm-6 2h6v1H8v-1zm6-4H8v-1h6v1z" />
      </g>
    </svg>

  ),

  subMenu: [
    {
      id: `main-menu-2-all`,
      path: '/management/dbn-cloud/dbn-cockpit',
      label: 'DBN Cockpit',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [],
    },

    {
      id: `main-menu-2-all`,
      path: '/management/dbn-cloud/one-taxonomy/domains',
      label: 'ONE Taxonomy',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [
         {
      id: `main-menu-2-all`,
      path: '/management/dbn-cloud/one-taxonomy/domains',
      label: 'Domains',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [],
    },

     {
      id: `main-menu-2-all`,
      path: '/management/dbn-cloud/one-taxonomy/categories',
      label: 'Categories',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [],
    },
    
      ],
    },

     {
      id: `main-menu-2-all`,
      path: '/management/dbn-cloud/global-community',
      label: 'Global Community',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [],
    },
      {
      id: `main-menu-2-all`,
      path: '/management/dbn-cloud/global-event',
      label: 'Global Event',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [],
    },

    {
      id: `main-menu-2-all`,
      path: '/management/dbn-cloud/global-program',
      label: 'Global Program',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [],
    },

     {
      id: `main-menu-2-all`,
      path: '/management/dbn-cloud/dbnie',
      label: 'DBN IE',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: []
    },
   
   {
            id: `coln-1-collections`,
            label: 'DBN',
            path: '/management/organization/dbn/dbnp',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM5 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm14 2a7 7 0 0 1 0 14H5a7 7 0 0 1 0-14h14zM5 22h14V13H5v9z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),
            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'DBNP ',
                    path: '/management/organization/dbn/dbnp',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM5 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm14 2a7 7 0 0 1 0 14H5a7 7 0 0 1 0-14h14zM5 22h14V13H5v9z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'DBNP Mapping',
                    path: '/management/organization/dbn/dbnp-mappings',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM5 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm14 2a7 7 0 0 1 0 14H5a7 7 0 0 1 0-14h14zM5 22h14V13H5v9z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'DBNP Registry',
                    path: '/management/organization/dbn/dbnp-registries',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM5 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm14 2a7 7 0 0 1 0 14H5a7 7 0 0 1 0-14h14zM5 22h14V13H5v9z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'OrgRegistry',
                    path: '/management/organization/dbn/org-registries',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM5 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm14 2a7 7 0 0 1 0 14H5a7 7 0 0 1 0-14h14zM5 22h14V13H5v9z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
            ]
        },
   
    {
      id: `main-menu-2-all`,
      path: '/management/dbn-cloud/dbas',
      label: 'DBAs',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [
        {
          id: `coln-1-Categories`,
          label: 'DBAs',
          path: '/management/dbn-cloud/dbas',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },

        {
          id: `coln-1-Categories`,
          label: 'DBA Types',
          path: '/management/dbn-cloud/dba-types',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },
        


      ],
    },
    {
      id: `main-menu-2-all`,
      path: '/management/dbn-cloud/biznet/dbnbizs',
      label: 'BIZNet',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [
        {
          id: `coln-1-Categories`,
          label: 'DBNBizs',
          path: '/management/dbn-cloud/biznet/dbnbizs',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'BIZNet Types',
          path: '/management/dbn-cloud/dbnbizs/dbnbiz-types',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#ffffff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fill="#ffffff" fill-rule="evenodd" d="M20 10a1 1 0 0 1-1 1h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 1 1zM7 14.019zm5 2.001a1 1 0 0 1-1 1 1.021 1.021 0 0 1-.79-.38l-.04-.06A6.177 6.177 0 0 0 7 14.15 3.663 3.663 0 0 0 6 14v1.02a.976.976 0 0 1-.55.87 1 1 0 0 1-1.05-.09l-4-3a1 1 0 0 1 0-1.6l4-3a.99.99 0 0 1 1.05-.09.988.988 0 0 1 .55.87V10c2.15 0 5.91 3.1 6 6.02zM20 14a1 1 0 0 1-1 1h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1zm0 4a1 1 0 0 1-1 1h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1zm0-12a1 1 0 0 1-1 1h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 1 1z"></path>
                <path fill="#ffffff" fill-rule="evenodd" d="M24 2v20a2.006 2.006 0 0 1-2 2H8a2.006 2.006 0 0 1-2-2v-3a1 1 0 0 1 2 0v2.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-19a.487.487 0 0 0-.49-.5H8.5a.5.5 0 0 0-.5.5V5a1 1 0 0 1-2 0V2a2.006 2.006 0 0 1 2-2h14a2.006 2.006 0 0 1 2 2z"></path>
              </g>
            </svg>
          ),
        },
    ],
    },
    {
      id: `main-menu-2-all`,
      path: '/management/dbn-cloud/agentnet/dbn-agents',
      label: 'AgentNet',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [
        {
          id: `coln-1-Categories`,
          label: 'DBN Agents',
          path: '/management/dbn-cloud/agentnet/dbn-agents',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'AgentNet Types',
          path: '/management/dbn-cloud/agentnet/agent-net-types',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },
        

      ],
    },
  ]
})
